import { type I18N } from '.';

export const nb = {
  loginWith: 'Logg inn med',
  approveWith: 'Godkjenne med',
  signWith: 'Signer med',
  confirmWith: 'Bekreft med',
  acceptWith: 'Aksepterer med',
  sameDevice: 'På denne enhet',
  anotherDevice: 'Med personnummeret ditt',
  anotherDeviceQR: 'På annan enhet',
  mitidBusiness: 'MitID Erhverv',
  finnishMobileID: 'Finsk Mobilsertifikat',
  finnishBankID: 'Finsk Bank ID',
  swedishBankID: 'Svensk BankID',
  norwegianBankID: 'Norsk BankID',
  biometrics: 'Biometri',
  openAndScan: 'Åpne BankID-appen på mobilenheten din og skann QR-koden.',
  thisIsTheQR: 'Dette er en BankID QR-kode. Du kan klikke på den for å se den i fullskjerm.',
  completingLogin: 'Fullfører påloggingen.',
} satisfies I18N;
